// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2rVuW","content":"LoadingAlert_content__wl5z6"};